import script from "./UploadImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImage.vue?vue&type=script&setup=true&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=a240aafc&lang=scss"

const __exports__ = script;

export default __exports__